import {
  addAsset,
  updateAsset,
} from '../../store/slices/assetsSlice';
import {
  addTimelineItem,
} from '../../store/slices/timelineSlice';
import {
  setEditingPlaceholderContext,
  setPlaceholderModalVisible,
} from '../../store/slices/editorUISlice';

export function createPlaceholderHandlers({
  dispatch,
  currentTime,
  selectedItemId,
  currentItem,
  editingPlaceholderContext,
}) {
  const closePlaceholderModal = () => {
    dispatch(setPlaceholderModalVisible(false));
    dispatch(setEditingPlaceholderContext(null));
  };

  const handleCreatePlaceholder = ({ title, description }) => {
    const assetId = `placeholder-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const duration = 5;

    dispatch({
      ...addAsset({
        id: assetId,
        type: 'placeholder',
        name: title.trim(),
        url: null,
        thumbnail_url: null,
        duration,
        source_type: 'placeholder',
        metadata: {
          description: description.trim(),
        },
      }),
      meta: { undoable: true },
    });

    dispatch({
      ...addTimelineItem({
        assetId,
        duration,
        currentTime,
        anchorItemId: selectedItemId || currentItem?.id,
      }),
      meta: { undoable: true },
    });

    closePlaceholderModal();
  };

  const handleOpenEditPlaceholder = (asset, item) => {
    dispatch(setEditingPlaceholderContext({
      assetId: asset.id,
      sectionId: item.metadata?.sectionId || asset.metadata?.sectionId || null,
      itemId: item.id,
      title: asset.name || '',
      description: asset.metadata?.description || '',
      metadata: asset.metadata || {},
    }));
    dispatch(setPlaceholderModalVisible(true));
  };

  const updatePlaceholder = ({ title, description }) => {
    if (!editingPlaceholderContext?.assetId) {
      closePlaceholderModal();
      return;
    }

    dispatch({
      ...updateAsset({
        id: editingPlaceholderContext.assetId,
        changes: {
          name: title.trim(),
          metadata: {
            ...(editingPlaceholderContext.metadata || {}),
            description: description.trim(),
          },
        },
      }),
      meta: { undoable: true },
    });

    closePlaceholderModal();
  };

  return {
    handleCreatePlaceholder,
    handleOpenEditPlaceholder,
    updatePlaceholder,
    closePlaceholderModal,
  };
}
